// The printers this browser knows (paired print server printers) and their keys, in IndexedDB.
// A record: {id, kind: 'full' | 'reader', secret: Uint8Array(32) (K or R), name, added}. The id,
// credentials and encryption key are derived from the secret (crypto.js), and the printer's real name
// lives encrypted on the server; `name` here is only a local label for the list.
import { run } from '../core/db.js';

export function openKeyStore(opened) {
  return {
    loadAll: () => run(opened, 'printers', 'readonly', (s) => s.getAll()),
    save: (rec) => run(opened, 'printers', 'readwrite', (s) => s.put(rec)),
    remove: (id) => run(opened, 'printers', 'readwrite', (s) => s.delete(id)),
  };
}

// Adds (or upgrades) a printer from a login item {kind, secret} (crypto.js parseLoginFragment) given its derived id.
// A full key replaces a reader key of the same printer, never the other way round. Returns the stored record.
export async function addPrinter(store, { kind, secret }, id, name = '') {
  const existing = (await store.loadAll()).find((r) => r.id === id);
  if (existing && (existing.kind === 'full' || kind === 'reader')) return existing;
  const rec = { id, kind, secret, name: existing?.name || name, added: existing?.added ?? Date.now() };
  await store.save(rec);
  return rec;
}
